import { Grid } from "@mui/material";
// import useStyles from "./styles";
import Button from "../../../components/Button";
import { useState, useEffect } from "react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import useStyles from "../../inventory/styles";
import { Icon } from "@iconify/react";
import { InventoryCondition } from "../../../utils/DropDown";

const INVENTORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory";
const INVENTORY_CATEGORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory";
const EMPLOYEES_ENDPOINT = "/api/v1/employees";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const EditInventory = ({ item_id }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isGetting, setIsGetting] = useState(false);
  const [inventoryCategory, setInventoryCategory] = useState([]);
  const [inventoryValidator, showInventoryValidator] = useValidator();
  const [employeeData, setEmployeesData] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const { id } = useParams();

  const [editInventoryForm, setEditInventoryForm] = useState({
    name: "",
    description: "",
    category: "",
    employee_in_charge: "",
    quantity: "",
    condition: "",
    status: "",
    images: []
  });

  const handleEditFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFile(prev => [...prev, ...files]);
  };

  const handleRemoveFile = (type, index) => {
    if (type === "existing") {
      const updatedImages = [...editInventoryForm.images];
      updatedImages.splice(index, 1);
      setEditInventoryForm(prev => ({
        ...prev,
        images: updatedImages
      }));
    } else if (type === "new") {
      const updatedSelected = [...selectedFile];
      updatedSelected.splice(index, 1);
      setSelectedFile(updatedSelected);
    }
  };

  const getAllInventoryCategory = () => {
    httprequest.get(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/categories`).then((res) => {
      setInventoryCategory(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const getCurentInventory = () => {
    setIsGetting(true);
    httprequest.get(`${INVENTORY_ENDPOINT}/${item_id}/inventory?hostel_id=${id}`).then((res) => {
      setEditInventoryForm({ ...editInventoryForm,
        name: res?.data?.data?.name,
        description: res?.data?.data?.description,
        category: res?.data?.data?.category?.id,
        employee_in_charge: res?.data?.data?.employee_in_charge?.id,
        quantity: res?.data?.data?.quantity?.toString(),
        status: res?.data?.data?.status,
        images: res?.data?.data?.images,
        condition: res?.data?.data?.condition });
      setIsGetting(false);
    }).catch((err) => {
      setIsGetting(false);
      toast.error(err?.response?.data);
    });
  };

  const getAllEmployees = () => {
    httprequest.get(EMPLOYEES_ENDPOINT).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleEditInventory = async () => {
    if (!inventoryValidator.allValid()) {
      showInventoryValidator(true);

      return;
    }

    setIsLoading(true);

    try {
      let uploadedImages = [];

      // Upload new images if any
      if (selectedFile?.length > 0) {
        const formData = new FormData();
        selectedFile.forEach((file) => {
          formData.append("file", file);
        });

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response?.status === 200 && response?.data?.data) {
          uploadedImages = response?.data?.data.map((file) => ({
            upload_id: file?.upload_id,
            file_url: file?.file_url
          }));
        }
      }

      // Combine old and new images in current Inventory
      const combinedImages = [...editInventoryForm.images, ...uploadedImages];

      // Prepare final data
      const updatedData = {
        ...editInventoryForm,
        images: combinedImages
      };

      const res = await httprequest.patch(`${INVENTORY_ENDPOINT}/${item_id}?hostel_id=${id}`, updatedData);

      setIsLoading(false);
      navigate(`/hostel/${id}`);
      toast.success(res?.data?.message);

      setEditInventoryForm({
        ...editInventoryForm,
        name: "",
        description: "",
        category: "",
        employee_in_charge: "",
        quantity: "",
        condition: "",
        images: []
      });

      setSelectedFile([]);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditInventoryForm({ ...editInventoryForm, [name]: value });
  };

  useEffect(() => {
    getAllInventoryCategory();
    getAllEmployees();
    getCurentInventory();
  }, []);

  const { name, description, category, employee_in_charge, quantity, condition, status } = editInventoryForm;

  return (
    <>
      <div className="page-content margin-top-16">
        {isGetting ? (
          <PageLoader />
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup
                  label="Product Name"
                  margin="normal"
                  placeHolder="Enter product name"
                  inputType="text"
                  inputName="name"
                  value={name}
                  onChange={handleChange}
                />
                {inventoryValidator.message("Product Name", name, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup
                  label="Description"
                  margin="normal"
                  inputType="text"
                  inputName="description"
                  value={description}
                  onChange={handleChange}
                />
                {inventoryValidator.message("Description", description, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup label="Category" children={
                  <select onChange={handleChange} name="category" value={category}>
                    <option value="">--- Select ---</option>
                    {inventoryCategory?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>{data?.category}</option>
                      );
                    })}
                  </select>
                }
                />
                {inventoryValidator.message("Category", category, "required")}
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <InputGroup
                  label="Quantity"
                  margin="normal"
                  placeHolder=""
                  inputType="text"
                  inputName="quantity"
                  value={quantity}
                  onChange={handleChange}
                />
                {inventoryValidator.message("Quantity", quantity, "required")}
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <SelectGroup label="Condition" children={
                  <select name="condition" onChange={handleChange} value={condition}>
                    <option value="">--- Select ---</option>
                    {InventoryCondition?.map((conditions) => {
                      return (
                        <option key={conditions?.key} value={conditions?.key}>{conditions?.text}</option>
                      );
                    })}
                  </select>
                }
                />
                {inventoryValidator.message("Condition", condition, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup label="Teacher in Charge" children={
                  <select onChange={handleChange} name="employee_in_charge" value={employee_in_charge}>
                    <option value="">--- Select ---</option>
                    {employeeData?.map((employee) => {
                      return (
                        <option key={employee?.employee_id} value={employee?.employee_id}>{employee?.first_name}{" "}{employee?.last_name}</option>
                      );
                    })}
                  </select>
                }
                />
                {inventoryValidator.message("Employee", employee_in_charge, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup label="Status" children={
                  <select onChange={handleChange} name="status" value={status}>
                    <option value="">--- Select ---</option>
                    <option value="archived">Archived</option>
                    <option value="active">Active</option>
                    <option value="available">Available</option>
                  </select>
                }
                />
                {inventoryValidator.message("Status", status, "required")}
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <div className={classes.fordesc}>
                  <p>Add Image</p>
                </div>

                <div className={classes.pickercontainer}>
                  <input
                    type="file"
                    multiple
                    className={classes.picker}
                    onChange={handleEditFileChange}
                    name="file"
                    accept="image/jpeg,image/jpe,image/png"
                  />

                  <div className={classes.uploadflex}>
                    <div>
                      <Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} />
                    </div>

                    {selectedFile?.length > 0 ? (
                      <div>
                        <p className={classes.uploadtitle}>Images Added</p>
                        <p className={classes.uploadsubtitle}>
                          {selectedFile.length} file{selectedFile.length > 1 ? "s" : ""} selected
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className={classes.uploadtitle}>Tap to Upload</p>
                        <p className={classes.uploadsubtitle}>SVG, PNG, JPG | 10MB max.</p>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
              {(editInventoryForm?.images?.length > 0 || selectedFile?.length > 0) && (
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.previewGrid}>
                    {/* Existing images from editInventoryForm */}
                    {editInventoryForm.images.map((img, index) => (
                      <div key={`existing-${index}`} className={classes.previewItem}>
                        <img src={img.file_url} alt={`existing-${index}`} className={classes.previewImage} />
                        <div
                          className={classes.removeBtn}
                          onClick={() => handleRemoveFile("existing", index)}
                        >
                          <Icon icon="zondicons:minus-solid" /> Remove
                        </div>
                      </div>
                    ))}

                    {/* Newly selected files */}
                    {selectedFile?.map((file, index) => {
                      const fileUrl = URL.createObjectURL(file);

                      return (
                        <div key={`new-${index}`} className={classes.previewItem}>
                          <img src={fileUrl} alt={`new-${index}`} className={classes.previewImage} />
                          <div
                            className={classes.removeBtn}
                            onClick={() => handleRemoveFile("new", index)}
                          >
                            <Icon icon="zondicons:minus-solid" /> Remove
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Grid>
              )}
            </Grid>
            <div className="margin-top-16">
              <Button variant="primary" buttonSize="medium" color="btndefault" buttonName="Edit Inventory" onClick={handleEditInventory} isLoading={isLoading} />
            </div>
          </>
        )}
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default EditInventory;
